/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';
import { GetPastiDaPreparareDTO } from '../model/getPastiDaPreparareDTO';
import { ReportMensileDTO } from '../model/reportMensileDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PastiDaPreparareService {

    protected basePath = 'https://demo-api.mensapp.it/gestione-mense';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Permette di forzare il calcolo dei pasti.
     * Forza il ricalcolo del numero di pasti da preparare per un comune in una data specifica, sovrascrivendo eventuali calcoli precedenti.
     * @param slugComune 
     * @param data 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public calcolaPastiDaPreparare(slugComune: string, data: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public calcolaPastiDaPreparare(slugComune: string, data: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public calcolaPastiDaPreparare(slugComune: string, data: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public calcolaPastiDaPreparare(slugComune: string, data: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling calcolaPastiDaPreparare.');
        }

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling calcolaPastiDaPreparare.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (data !== undefined && data !== null) {
            queryParameters = queryParameters.set('data', <any>data);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/pasti-da-preparare/update`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere il report dei pasti da preparare per un determinato giorno.
     * Restituisce il dettaglio dei pasti da preparare per un comune in una data specifica (formato dd/MM/yyyy), suddivisi per tipologia.
     * @param slugComune 
     * @param data 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPastiDaPreparare(slugComune: string, data: string, observe?: 'body', reportProgress?: boolean): Observable<GetPastiDaPreparareDTO>;
    public getPastiDaPreparare(slugComune: string, data: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetPastiDaPreparareDTO>>;
    public getPastiDaPreparare(slugComune: string, data: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetPastiDaPreparareDTO>>;
    public getPastiDaPreparare(slugComune: string, data: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling getPastiDaPreparare.');
        }

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling getPastiDaPreparare.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (data !== undefined && data !== null) {
            queryParameters = queryParameters.set('data', <any>data);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetPastiDaPreparareDTO>('get',`${this.basePath}/api/v1/pasti-da-preparare`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere il report dei pasti da preparare tra una data di inizio e fine.
     * Restituisce il report aggregato dei pasti da preparare per un comune nell&#x27;intervallo di date specificato (formato dd/MM/yyyy).
     * @param slugComune 
     * @param dataInizio 
     * @param dataFine 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPastiDaPreparareReport(slugComune: string, dataInizio: string, dataFine: string, observe?: 'body', reportProgress?: boolean): Observable<GetPastiDaPreparareDTO>;
    public getPastiDaPreparareReport(slugComune: string, dataInizio: string, dataFine: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetPastiDaPreparareDTO>>;
    public getPastiDaPreparareReport(slugComune: string, dataInizio: string, dataFine: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetPastiDaPreparareDTO>>;
    public getPastiDaPreparareReport(slugComune: string, dataInizio: string, dataFine: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling getPastiDaPreparareReport.');
        }

        if (dataInizio === null || dataInizio === undefined) {
            throw new Error('Required parameter dataInizio was null or undefined when calling getPastiDaPreparareReport.');
        }

        if (dataFine === null || dataFine === undefined) {
            throw new Error('Required parameter dataFine was null or undefined when calling getPastiDaPreparareReport.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (dataInizio !== undefined && dataInizio !== null) {
            queryParameters = queryParameters.set('dataInizio', <any>dataInizio);
        }
        if (dataFine !== undefined && dataFine !== null) {
            queryParameters = queryParameters.set('dataFine', <any>dataFine);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetPastiDaPreparareDTO>('get',`${this.basePath}/api/v1/pasti-da-preparare/report`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere il report mensile dei pasti da preparare tra una data di inizio e fine.
     * Restituisce il report dei pasti da preparare disaggregato per mese per un comune nell&#x27;intervallo di date specificato (formato dd/MM/yyyy). Ogni elemento dell&#x27;array rappresenta un mese con i totali per scuola.
     * @param slugComune 
     * @param dataInizio 
     * @param dataFine 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportMensile(slugComune: string, dataInizio: string, dataFine: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ReportMensileDTO>>;
    public getReportMensile(slugComune: string, dataInizio: string, dataFine: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReportMensileDTO>>>;
    public getReportMensile(slugComune: string, dataInizio: string, dataFine: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReportMensileDTO>>>;
    public getReportMensile(slugComune: string, dataInizio: string, dataFine: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling getReportMensile.');
        }

        if (dataInizio === null || dataInizio === undefined) {
            throw new Error('Required parameter dataInizio was null or undefined when calling getReportMensile.');
        }

        if (dataFine === null || dataFine === undefined) {
            throw new Error('Required parameter dataFine was null or undefined when calling getReportMensile.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (dataInizio !== undefined && dataInizio !== null) {
            queryParameters = queryParameters.set('dataInizio', <any>dataInizio);
        }
        if (dataFine !== undefined && dataFine !== null) {
            queryParameters = queryParameters.set('dataFine', <any>dataFine);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReportMensileDTO>>('get',`${this.basePath}/api/v1/pasti-da-preparare/report-mensile`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
